import { AgentProfileEntityServiceImplementation } from "./entity-service-implementation/agent-profile-entity-service";
import { FlightingServiceImplementation } from "./flightingSvc";
import { UserTenantService } from "./user-tenant-service";

export class TelemetryReadytoSendService {
  private readyDeferral: ng.IDeferred<any>;
  // @ngInject
  constructor(
    agentProfileEntityService: AgentProfileEntityServiceImplementation,
    flightingService: FlightingServiceImplementation,
    userTenantService: UserTenantService,
    $q: ng.IQService,
    $timeout: ng.ITimeoutService
  ) {
    this.readyDeferral = $q.defer();
    if (userTenantService.isUserOnLegacyAuthTenant()) {
      this.readyDeferral.resolve();
    } else {
      $q.all([agentProfileEntityService.whenReady(), flightingService.whenReady()]).then(() =>
        this.readyDeferral.resolve()
      );
      $timeout(() => this.readyDeferral.resolve(), 10000);
    }
  }

  public whenReady(): ng.IPromise<any> {
    return this.readyDeferral.promise;
  }

  public shutdown() {
    this.readyDeferral.resolve();
  }
}
